import axiosClient from './axiosClient.js'

// Plaintext manifests published to QuizSystem/ETSData by studio/.
// Root:  { "years": [2022, ...] }
// Year:  { "year": 2022, "tests": [{ "test": 1, "parts": [1,2,...] }] }
const manifestAPI = {
  getRoot: () => {
    return axiosClient.get('/ETSData/master/manifest.json');
  },
  getYear: (year) => {
    return axiosClient.get(`/ETSData/master/${year}/manifest.json`);
  },
}

export default manifestAPI;
